"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.geo = void 0;
exports.geo = {
    find: {
        method: 'get',
        path: '/geo-info/places',
        response: {},
    },
    findOne: {
        method: 'get',
        params: ['id'],
        path: '/geo-info/places/:id',
        response: {},
    },
    children: {
        method: 'get',
        params: ['id'],
        path: '/geo-info/children/:id',
        response: {},
    },
    countries: {
        method: 'get',
        path: '/geo-info/countries',
        response: {},
    },
    provinces: {
        method: 'get',
        params: ['id'],
        path: '/geo-info/countries/:id/provinces',
        response: {},
    },
    districts: {
        method: 'get',
        params: ['id'],
        path: '/geo-info/provinces/:id/districts',
        response: {},
    },
    airports: {
        method: 'get',
        path: '/geo-info/airports',
        response: {},
    },
    address: {
        method: 'get',
        path: '/geo-info/address',
        response: {},
    },
    coordinates: {
        method: 'get',
        params: ['coordinates'],
        path: '/geo-info/near/:coordinates',
        response: {},
    },
};
//# sourceMappingURL=geo.api.js.map